<div class="section">
  <div class="section__header">
    <h2 class="section__header-text">Additional Remarks</h2>
    <button id="addRemarkButton" (click)="openEditRemarkDialog(null)" mat-mini-fab *ngIf="editModeSet">
      <mat-icon aria-label="Add Remark">add</mat-icon>
    </button>
  </div>
  <div class="section__body">
    <ng-container *ngIf="additionalRemarks.length > 0; else placeholder">
      <div class="remark__container" *ngFor="let remark of additionalRemarks; let i = index">
        <div class="remark__actions">
          <mat-icon (click)="openEditRemarkDialog(i)" *ngIf="editModeSet && (remark.sourceId === 5 || remark.sourceId === 10 || remark.sourceId === 12)"
                    class="edit-icon" mat-tooltip="Edit" aria-label="Edit remark">edit</mat-icon>
          <mat-icon (click)="deleteRemark(i)" *ngIf="editModeSet && (remark.sourceId === 5 || remark.sourceId === 10 || remark.sourceId === 12)"
                    class="delete-icon" mat-tooltip="Delete" aria-label="Delete remark">delete_outline</mat-icon>
        </div>
        <app-data-item [source]="remark.sourceId" [compact]="false"
                       [showLabel]="true" [linkify]="true" [flex]="false">
          {{ (remark.sourceId === 10 || remark.sourceId === 12) ? "(" + remark.commentRef + ") " + remark.text : remark.text }}
        </app-data-item>
      </div>
    </ng-container>
  </div>
</div>

<ng-template #placeholder>
  <div class="detail-page__placeholder">
    <mat-icon class="detail-page__placeholder-icon">info</mat-icon>
    <div class="detail-page__placeholder-message">There are no additional remarks for {{airport.identifier}}.</div>
  </div>
</ng-template>
